import API from "../../..";
import { fullUrl } from '../../../utile/utile.api';

/* 物件物理削除（イズミ管理者のみ使用可能） */

const path = '/physics-delete';

const physicsDelete = (url: string) => () => {
  const full = fullUrl(url, path);
  return ({
    delete: () => API.con.delete<{}, {}>({ url: full, data: {} }),
  })
}

export default physicsDelete;
